module.exports = __webpack_public_path__ + "static/media/screenshot3.17eda7dd.png";